import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

export const CameraButton = ({
  onClick,
  onFocus,
  isRequired,
  isInvalid,
  isReadOnly,
  hasResourceUpdateHighlight,
  children,
}) => (
  <button
    type="button"
    aria-label="Camera"
    onClick={onClick}
    onFocus={onFocus}
    className={clsx(
      'camera-button',
      isRequired && 'required',
      isInvalid && 'invalid',
      isReadOnly && 'read-only',
      hasResourceUpdateHighlight && 'updateHighlight'
    )}
  >
    {children}
    <p>Camera</p>
  </button>
);

CameraButton.propTypes = {
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  isRequired: PropTypes.bool,
  isInvalid: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  hasResourceUpdateHighlight: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

CameraButton.defaultProps = {
  onClick: () => {},
  onFocus: () => {},
  isRequired: false,
  isInvalid: false,
  isReadOnly: false,
  hasResourceUpdateHighlight: false,
};

